import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShield = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 731 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M621.714 548.571v-365.714h-256v649.714c29.143-15.429 76-42.286 121.714-78.286 61.143-48 134.286-122.857 134.286-205.714zM731.429 109.714v438.857c0 240.571-336.571 392.571-350.857 398.857-4.571 2.286-9.714 3.429-14.857 3.429s-10.286-1.143-14.857-3.429c-14.286-6.286-350.857-158.286-350.857-398.857v-438.857c0-20 16.571-36.571 36.571-36.571h658.286c20 0 36.571 16.571 36.571 36.571z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgShield);
export default ForwardRef;
